const palette = {
    primaryBlue: '#102C3D',
    aquaBlue: '#689D9D',
    successGreen: '#5EA667',
    failureRed: '#EA8567',
    lightRed: '#F2C7AE',
    accentMoon: '#999999',
    accentOrange: '#FD5631',
    accentFeatured: '#E6C77A',
    accentSurf: '#93C9C3',
    accentSand: '#F1E8C3',
    accentSky: '#D9EFEC',
    primaryText: '#1E1B2C',
    lightText: '#666276',
    lighterText: '#9691A4',
    lightestText: '#F6F6F4',
    inputText: '#102C3D',
    inputBorder: '#D5D2DC',
    focusBorder: '#A5A2AC',
    lightBorder: '#EFECF3',
    socialButton: '#3C76F2',
    checkboxColor: '#CDC9D5',
    whiteColor: '#FFFFFF',
    lightScrollbar: '#F1F1F1',
    opacityBackground: 'rgba(245, 245, 245, 0.8)',
    overlayBackground: 'rgba(0, 0, 0, 0.4)',
    primaryOpacity: 'rgba(16, 44, 61, .8)',
    specialOfferColor: '#6493FC',
};

const fonts = {
    mainFont: 'Montserrat',
    sourceSansPro: 'Source Sans Pro',

};

const heights = {
    nav: '3.5rem',
    navHalf: '1.75rem',
    mobileSettingsControls: '60px',
    mobileSettingsControlsHalf: '30px',
    mobileButtonWidth: '40px',
    mapHeader: '4rem',
};

export { palette, fonts, heights };
